import React, { useState } from 'react';
import {toast} from "react-toastify";
import { useNavigate } from 'react-router-dom';
import { deleteAccount } from '../apiServices/apiServices';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CustomToastContainer from '../components/CustomToastContainer';

export default function DeleteAccount() {
  const navigate = useNavigate();
  const [isChecked, setIsChecked] = useState(false);

  const handleDelete = async () => {
    const user = JSON.parse(window.localStorage.getItem("user"));
    try {
      const response = await deleteAccount(user.id);
      // console.log("Response : ", response);
      if (response && response.success) {
        navigate('/login');
      } else {
        toast.error(response.message || 'Request failed');
      }
    } catch (error) {
      console.error('Error:', error);
      toast.error('An error occurred. Please try again.');
    }
  };

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <>
      <div className=" w-full h-full ">
        <nav className="flex items-center justify-between p-2 sm:p-4 bg-white shadow-md">
          <button className="text-gray-600 items-center" onClick={() => handleNavigation('/')}>
            <FontAwesomeIcon icon={faArrowLeft} size="lg" />
          </button>
          <div className="flex items-center justify-center flex-grow gap-2">
            <h1 className="text-gray-600 font-semibold text-lg">
            Delete Account
            </h1>
          </div>
        </nav>  
      </div>
      <div className="flex flex-col items-center w-full h-full p-4 md:p-10">
        <div className="w-full max-w-lg p-4 md:p-10 bg-white rounded-lg shadow-sm">
          <h2 className="text-lg font-medium mb-2 text-[#BE1F18]">Delete your account?</h2>
          <p className="text-gray-600 mb-6">
            Deleting your account will remove all your data from our system and cannot be undone.
          </p>

          <div className="absolute lg:bottom-12 md:bottom-12 bottom-5 flex flex-col items-center pr-4 ">
            <div className="flex items-start mb-6">
              <input
                type="checkbox"
                id="confirmDelete"
                className="w-6 h-6 text-red-600 accent-[#BE1F18] border-gray-300 rounded focus:ring-red-500"
                checked={isChecked}
                onChange={() => setIsChecked(!isChecked)}
              />
              <label htmlFor="confirmDelete" className="ml-3 text-gray-700">
                I understand the consequences of deleting my account.
              </label>
            </div>
            <button
              className="w-full py-2 mb-2 mt-5 mb-7 text-lg font-semibold text-red-600 border border-red-600 rounded-md focus:outline-none hover:bg-red-50"
            >
              Keep Account
            </button>
            <button
              onClick={handleDelete}
              className={`w-full py-2 text-lg font-semibold text-white rounded-md ${isChecked ? 'bg-red-600 hover:bg-red-700' : 'bg-red-300 cursor-not-allowed'}`}
              disabled={!isChecked}
            >
              Delete Account
            </button>
          </div>
        </div>
      </div>
      <CustomToastContainer/>
    </>
  );
}
